import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./floor-detail-draw.module.scss";
import FloorInputDraw from "../floor-input/floor-input-draw";
import VelavuButton from "../../../../elements/velavu-button";
import {
	FloorEditDataState,
	FloorEditState,
} from "../../../../state/floor/floor-edit-state";
import { makeStyleable } from "../../../../helper/icon-helper";
import IconCheckCircleFilled from "../../../../dynamicicons/icon-check-circle-filled";
import VelavuSavedIndicator from "../../../../elements/velavu-saved-indicator";

export interface FloorDetailDrawProps {
	state: FloorEditState;
}

export default function FloorDetailDraw(props: FloorDetailDrawProps) {
	const { t } = useTranslation();

	return (
		<div className={styles.content}>
			<FloorInputDraw
				drawTool={props.state.drawToolType}
				onChangeDrawTool={props.state.setDrawToolType}
				floors={props.state.referenceFloors}
				referenceFloorID={props.state.referenceFloorID}
				onSelectReferenceFloor={props.state.setReferenceFloorID}
			/>

			{props.state.dataState === FloorEditDataState.Saved ? (
				<VelavuSavedIndicator
					className={styles.primaryButton}
					fullWidth
				/>
			) : (
				<VelavuButton
					className={styles.primaryButton}
					label={t("common.save")}
					disabled={
						props.state.dataState === FloorEditDataState.Idle ||
						props.state.dataState === FloorEditDataState.Saving
					}
					loadingIndicator={
						props.state.dataState === FloorEditDataState.Saving
					}
					fullWidth
					onClick={props.state.submit}
				/>
			)}
		</div>
	);
}
